import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import datePickerMessages from './DatePicker';

var messages = _objectSpread(_objectSpread({}, datePickerMessages), {}, {
  placeholder: '時刻を選択',
  quickSelect: 'クイック選択',
  customTime: 'カスタム時間',
  now: '現在',
  confirm: '確認'
});

export default messages;